import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useGetRooms } from 'store/services/firebase-broadcast';

const findRoomById = (rooms: any[], roomId: string) =>
  rooms.find((room: any) => String(room.pk) === String(roomId));

const ChatRoomRedirect: React.FC = () => {
  const { roomId } = useParams<{ roomId: string }>();
  const history = useHistory();
  const allRooms = useGetRooms();

  useEffect(() => {
    if (!roomId) return;

    const roomFromUrl = findRoomById(allRooms, roomId);

    if (roomFromUrl) {
      history.replace('/chat-room', { selected: roomFromUrl, preserveSelection: true });
      return;
    }

    if (allRooms.length > 0) {
      history.replace('/chat-room');
    }
  }, [roomId, allRooms, history]);

  return <div />;
};

export default ChatRoomRedirect;
